<template>
  <div class="contianer">
    <div class="header">
      <div class="header-container flex-box">
        <div>
          <img src="../assets/pk-logo.png" alt="" />
        </div>
        <div class="tap-box flex-box">
          <div
            class="tap-item"
            v-for="item in tapName"
            :key="item.index"
            @click="tapClick(item.index)">
            <span class="tap-name">{{ item.name }}</span>
            <span class="active-icon" v-if="item.index === activeName"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="body">
      <detail
        v-for="item in detailData"
        :key="item.index"
        :info="item"
      ></detail>
    </div>
    <div class="footer">
        <div style="background: #353232;align-content: center;">
            <img src="../assets/card.png" alt="" />
            <div style="background: #353232;align-content: center;">
              <a href="https://beian.miit.gov.cn/" rel="nofollow"><span style="color:#666;">京ICP备17069296号-4</span></a>
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAMAAABFjsb+AAACwVBMVEUAAADwvHjz2arv1pHvvZqY3f/V1dX/88G4i2vqxnfOsJLy3Jjy3InXr3X26rbw0Inx37n69Lj09LrlvFfmwFflvnnkwWjZpmHerFzis2Lt0Xnt2Hjnsljgs2K0kWnztFH03nmriXe5lnbdoFHirFveplLgr23ktGX03ojjsnzitXbbr3fy543q1nvMkEPszInu5pbr05zZsnHKhE/mzaXlynPr0Jvez4PivYfz0I7s07fpz4/mvYTTlWTx3Zjntnnsxl7mt1nktFXsuVPkr1Dbjj7PDQuBg4R3doEkJ3HDnnDqyGb20WPjtV4OAF4gAF3oxlrtxFrpu1NXQFDvuE3qs0zeqkrhoUrjqknnmTvWXC3zTiXWKxzUJxvoNhbSExXVBwswUJaIi5I1RpEBE44pRoy0roeMhIfMvIKzooGimoE4QIDVv35WXX4vNn7bwn0SEX1ua3pkY3oVFHoCB3mvoHcaH3X44HSHenMFAHHr0XD132/JsG8XFm8ZFW5NSm3ayGzVwWz64Gv2zWvgy2rqympdVWreuGliVmnkwWjxx2bpvmT5x2PUtGPmtmHwvmDmyF7qwl57Y17yyF3nvV2fc1yfdFv1zVrqv1ojFFqWd1lxW1n3v1aqhlaeb1bxx1UxIVX8y1TFoFQnA1TwvFPqtVLXl1I7EVLpt1HsrlHdl1GefFHqwFDkqU/lkk3ZmUzepUrjpEnCh0kvAEjfnUedY0ZYEUXmn0TvrEPgmkLKi0KIYkLemEH1pj/XiD9HAT7Ydz3omzvQhzrYgTp6ETr3gDnccDnwfjdPKjbRejTWZDOvaDKYXDHLai/ZaC/PYi/zeS3PVizHVivbUCvWSyrkXSnUTSftZCX3WCTNQyLTPyLtViHVNCD9aR2vChzvSxnQPhjkKReXABbTNxTeMBLXJxLaJxHBHRHSDQndHwfAAAU+H9SDAAAAQHRSTlMABwoFAwEDDcuzlI53SUVBNhcL/Pv5+fj28/Du6Ofl5ODa2trSzsvDv7+6ubOurqCZmId0cWpmZWBWUVA+KSUVhouRnwAAAWhJREFUGNNiAAMWJgEuRS4BJhYGOGA349h6ZvfqqRwm7DAhZt5pJ05HXV9XEzyPF6pSyFIueNN9tytut3M6lPiZQEKsfF4zZ92Nj70T8+po1gIvfpAYk6lH8a64hJj4WLcn7WWF5kxAZTbyHnWH4hJunbv84mm3Z5ECHxsDi9He9IJFF56fDQu/dry31n2hIRsDs3ZkZsrsg5dunoo6MGdSSdoOLWYGRvHDfYn+z25cBOz8seiHi1M7XWUZGRjV9vQkVT56+fjB1eh7fu7NazmB6jR39ucn+23ef2Tbcv+8xi4XkJjoslUrMyrqc+e2eWaXhoRHSDEysHE7r98X6TMhIMSpoWW764bpPEDvCXKLhJ2M8FmydHKTs6uvGA87yG9WkgGOToETHRxcXLxbJazZQEGgUV7l6xjkOGPjFqcp3tU6TCB1drrCQfOdQ0NXBK5xkDYQZAUHFqOtsZ6qsoyKur6FPTOQDwBia3h//vvwbwAAAABJRU5ErkJggg==" alt="">
              <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802042849" style="display:inline-block;">
                <span style="float:height:20px; color:#666;">京公网安备 11010802042849号</span>
              </a><span style="float:height:20px; color:#666;">&nbsp;&nbsp;&nbsp;&nbsp; Copyright © 北京萝卜青菜教育科技有限公司</span>
            </div>
       </div>
    </div>
  </div>
</template>

<script>
import detail from "./components/detail.vue";
export default {
  components: { detail },
  data() {
    return {
      contentData: [
        {
          index: 1,
          title: "英语内容研发",
          content:
            "北京萝卜青菜教育科技旗下Proud Kids教研团队拥有超过八年的国内外英语内容研发经验。团队依据欧洲共同语言参考标准CEFR设计成型多版教材，并与中国新课标结合设计成型并应用教学多版电子课件。在课件设计和教学应用中创作了超过100多款游戏化教学活动。",
          img: "img1.png",
          type: "",
          aciveName: "1",
        },
        {
          index: 2,
          title: "定制开发教学内容",
          content:
            "在过去的三年中，Proud Kids团队已经为多个知名出版社设计和制作多种英语教学内容并在全国广泛应用于教学。",
          img: "img2.png",
          type: "imgLeft",
          aciveName: "1",
        },
        {
          index: 3,
          title: "行业殊荣",
          content:
            "Proud Kids的教研团队在创始人Leeson老师的带领下，获得了Classin首届联合北师大的线上教育课程第一名。",
          img: "img3.png",
          type: "",
          aciveName: "1",
        },
        {
          index: 4,
          title: "TESOL英语教师培训",
          content:
            "Proud Kids的教研团队在创始人Leeson老师的带领下，获得了Classin首届联合北师大的线上教育课程第一名。TESOL（Teaching English to Speakers of Other Languages）国际英语教师资格证书，旨在提升英语教学能力与世界接轨，是全球公认的ESL（教授英语为第二语言）国际英语教师职业资格证书。",
          img: "img4.png",
          type: "",
          aciveName: "2",
        },
        {
          index: 5,
          title: "一线Tesol培训服务",
          content:
            "Proud Kids创始团队自主研发了更适合中国本土市场的TESOL教学培训体系，将多年的英语教学经验应用于英语教育从业者的教学能力提高上，帮助更多英语教育爱好者成为优秀的TESOL教师。",
          img: "img5.png",
          type: "imgLeft",
          aciveName: "2",
        },
        {
          index: 6,
          title: "高通过率培训成果",
          content:
            "目前累计通过超过350名优秀的TESOL教师，希望致力于在后期为国内输送更多更优秀的一线教师。",
          img: "img6.png",
          type: "",
          aciveName: "2",
        },
        {
          index: 7,
          title: "成人商务英语培训",
          content:
            "剑桥商务英语证书(BEC)考试是剑桥大学考试委员会 (UCLES) 专门为我国设计的英语水平考该项考试包括选择题和非选择题，主要对考生的英语读、写、听、说能力进行全面的测试。自试。1993年11月21日在我国开考第一级即BEC1，已有相当多的在职人士参与了该考试。",
          img: "img7.png",
          type: "",
          aciveName: "3",
        },
        {
          index: 8,
          title: "教师团队的精益求精",
          content:
            "优胜劣汰, 不断提升教师的教学能力，正式聘用后，每两周一次的在职培训，定期的教学研讨会和不定期的教学质量跟踪反馈系统都将时刻帮助教师进步。",
          img: "img8.png",
          type: "imgLeft",
          aciveName: "3",
        },

        {
          index: 9,
          title: "学员参与教师评价",
          content:
            "公开、公正的评价体系，每次上课结束后，学员都可以对教师的表现进行评价。经过数百万次的评分，教师的教学水平，教学特色都会公平公开地展现给每一位学员，帮助他们找到所最适合自己的老师。",
          img: "img9.png",
          type: "",
          aciveName: "3",
        },
        {
          index: 10,
          title: "SaaS技术服务",
          content:
            "Proud Kids在自主研发的班课排课系统Cloud Education，已经服务于多家上市公司和教育集团，Cloud Education基于Java 8 技术开发，采用Spring Cloud 微服务技术架构，分模块、分业务，分服务分而治之，实现了业务逻辑服务间集群负载与分发均衡，保证系统稳定性、可靠性。",
          img: "img11.png",
          type: "",
          aciveName: "4",
        },
        {
          index: 11,
          title: "多适配性开源应用场景",
          content:
            "Cloud Education，作为国内可以适应多场景，排课和管理的系统软件系统，多领域尝试和探索，目前可以适应小班课，大班课，一对一，等各种场景，并受到各类合作方的一致认可。",
          img: "img11.png",
          type: "imgLeft",
          aciveName: "4",
        },
        {
          index: 12,
          title: "稳定的代码质量",
          content:
            "基于 Spring Cloud Greenwich 、Spring Security OAuth2 的RBAC权限管理系统；持久层采用Mybatis中间件封装封装框架baomidou实现高效访问及集群分库分表，数据层使用Mysql+Nosql（Mongodb）+Redis针对不同业务数据分而存储，保证数据高效访问和系统稳定。",
          img: "img11.png",
          type: "",
          aciveName: "4",
        },
        {
          index: 13,
          title: "集团介绍",
          content:
            "隶属于中国香港地区 Proud Kids Online Education Limited（蘿蔔青菜教育咨詢有限公司）大陆分公司。" +
              "北京萝卜青菜教育科技有限公司致力于为中国知名出版社、教育公司提供优质英语教学内容；为中国英语教学爱好者提供专业TESOL教学培训；为教育公司布局SaaS班课管理系统和向在读大学生及已参加工作的商务白领提供剑桥商务英语培训课程。" +
              "Proud Kids Online Education Limited 致力于为全球6-15岁青少年提供在线ESL语言培训服务。Proud Kids 历经六年打造了多种ESL语言培训课程，并在英国和北美拥有强大专业的师资团队。自2018年创立至今，Proud Kids 已经为全球14个国家中上万名学员提供了在线ESL语言培训服务，学员遍及中国大陆、中国香港、日本、韩国、德国、意大利等地区。",
          img: "intro.png",
          type: "",
          aciveName: "5",
        },
      ],
      detailData: [],
      activeName: 5,
      tapName: [
          {
          index: 5,
          name: "集团简介"
        },
        {
          index: 1,
          name: "教研课程开发"
        },
        {
          index: 2,
          name: "TESOL英语教师培训"
        },
        {
          index: 3,
          name: "成人商务英语"
        },
        {
          index: 4,
          name: "SaaS技术服务"
        }
      ]
    };
  },
  created(){
    if (this._isMobile()) {
      location.href="https://m.proudkids.com"
    } 
  },
  mounted() {
    this.detailData = this.contentData.filter((item) => item.aciveName === "5");
  },
  methods: {
    tapClick(index) {
      this.activeName = index;
      this.detailData = this.contentData.filter(
        (item) => item.aciveName == index
      );
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  }
};
</script>

<style lang="scss" scoped>
.flex-box {
  display: flex;
}
.contianer {
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 100%;
  height: 100%;
  .header {
    height: 108px;
    background: #ffc825;
    .header-container {
      width: 1256px;

      margin: 0 auto;
      display: flex;
      justify-content: space-between;
    }
    .tap-box {
      margin-top: 41px;
      .tap-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: 70px;
        cursor: pointer;
        .active-icon {
          width: 32px;
          height: 5px;
          background: #ff7500;
          border-radius: 3px;
          margin-top: 12px;
        }
      }
      .tap-item:nth-child(1) {
        margin-left: 0px;
      }
      .tap-name {
        height: 24px;
        font-size: 16px;
        font-family: SourceHanSansSC-Regular, SourceHanSansSC;
        font-weight: 400;
        color: #2b3033;
        line-height: 24px;
        cursor: pointer;
      }
    }
  }

  .body {
    flex: 1;
  }
  .footer {
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    min-height: 160px;
    font-size: 16px;
    font-family: SourceHanSansSC-Regular, SourceHanSansSC;
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
    background: #353232;
  }
}
</style>
